<template>
	<resources-index :resources="resources" type="article" plural="articles"></resources-index>
</template>

<script>

import ResourcesIndex from '@/views/resources/Index'
import {sync} from "vuex-pathify";
export default {
	name: "ArticlesIndex",
	components: {
		ResourcesIndex
	},
	computed: {
		resources: sync('articles/articles'),
	},
}
</script>